<template>
  <div class="app-container complaint-list">
    <el-tabs v-model="activeName" @tab-click="onTabShow">
      <el-tab-pane label="待审核列表" name="unexamed" v-if="permissions.complaint_unaudited_list">
        <div class="complaint-list-filter">
          <el-row>
            <!-- <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select class="complaint-list-filter-value" v-model="listQuery.targetType" clearable size="small" @change="setCategory" placeholder="内容类别">
                  <el-option
                    v-for="item in targeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select class="complaint-list-filter-value" v-model="listQuery.complaintCategoryId" clearable size="small" placeholder="举报分类">
                  <el-option
                    v-for="item in postComplaintType"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-date-picker
                  class="complaint-list-filter-date"
                  v-model="listQuery.complainedTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  size="small"
                  placeholder="创建时间">
                </el-date-picker>
              </div>
            </el-col>
             <el-col :span="6">
              <el-input @keyup.enter.native="searchChange" class="complaint-list-filter-value" v-model.trim="listQuery.complainedBy" size="small" placeholder="举报者Birth Name或Full Name"></el-input>
            </el-col>
            <el-col :span="6">
              <el-input @keyup.enter.native="searchChange" class="complaint-list-filter-value" v-model.trim="listQuery.complainTo" size="small" placeholder="被举报者Birth Name或Full Name"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-button class="complaint-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
              <el-button class="complaint-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            </el-col>
          </el-row>
        </div>
          <avue-crud ref="crud"
                    :page.sync="page"
                    :data="tableData"
                    :table-loading="tableLoading"
                    :option="unhandledTableOption"
                    @current-change="currentChange"
                    @size-change="sizeChange">

            <template slot="complainedBy"
                      slot-scope="scope">
              <a v-if="scope.row.complainedByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedBy}}</a>
              <a v-if="scope.row.complainedByMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedBy}}</a>
            </template>

            <template slot="complainedByRealname"
                      slot-scope="scope">
              <a v-if="scope.row.complainedByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedByRealname}}</a>
              <a v-else href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedByRelatedPersonalMemberId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedByRelatedPersonalRealname}}</a>
            </template>

            <template slot="complainedTo"
                      slot-scope="scope">
              <a v-if="scope.row.complainedToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedTo}}</a>
              <a v-if="scope.row.complainedToMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedTo}}</a>
            </template>

            <template slot="complainedToRealname"
                      slot-scope="scope">
              <a v-if="scope.row.complainedToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedToRealname}}</a>
              <a v-else href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToRelatedPersonalMemberId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedToRelatedPersonalRealname}}</a>
            </template>

            <template slot="targetType"
                      slot-scope="scope">
                {{scope.row.targetType | formateTargetType}}
            </template>

            <template slot="handleResult"
                      slot-scope="scope">
                {{scope.row.handleResult | formateHandleResult}}
            </template>

            <template slot="thumbnailUrl"
                      slot-scope="scope">
                <a v-if="scope.row.hasAttachment" href="javascript:void(0);" @click="thumbnailDetail(scope.row.handleResult,scope.row.id)"
                  class="complaint-list-container-button">
                附件详情</a>
            </template>

            <template slot="content"
                      slot-scope="scope">
              <a href="javascript:void(0);" @click="toPostList(scope.row.targetType,scope.row.targetId)"
                  class="complaint-list-container-button">
                {{scope.row.content}}</a>
            </template>

            <template slot="menuLeft">
            </template>
            <template slot-scope="scope"
                      slot="menu">
              <el-button type="text"
                        size="mini"
                        v-if="permissions.complaint_ignore"
                        @click="ignoreOption(scope.row)">忽略</el-button>
              <el-button type="text"
                        size="mini"
                        v-if="permissions.complaint_ban"
                        @click="banOption(scope.row)">下架{{scope.row.targetType | formateTargetType}}</el-button>
              <el-button type="text"
                        size="mini"
                        v-if="permissions.complaint_wait"
                        @click="waitOption(scope.row)">待处理</el-button>
            </template>
          </avue-crud>
        <el-dialog title="忽略操作" :visible.sync="ignoreDialogVisible" width="40%" class="handle-dialog">
          <el-form ref="ignoreForm" :model="handleMsg" :rules="rules">
            <el-form-item prop="handleReason">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" style="visibility: collapse;">
                  <label class="handle-dialog-item-label">忽略原因:</label>
                </div>
                <el-input type="textarea" v-model.trim="handleMsg.handleReason"></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item prop="sendToComplainantContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToComplainant" @change="$refs.ignoreForm.validateField('sendToComplainantContent')">
                  <label class="handle-dialog-item-label">通知给投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToComplainant" v-model.trim="handleMsg.sendToComplainantContent"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="sendToRespondentContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToRespondent" @change="$refs.ignoreForm.validateField('sendToRespondentContent')">
                  <label class="handle-dialog-item-label">通知给被投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToRespondent" v-model.trim="handleMsg.sendToRespondentContent"></el-input>
              </div>
            </el-form-item> -->
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="confirmIgnore">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="ignoreDialogVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
        <el-dialog title="下架操作" :visible.sync="banDialogVisible" width="40%" class="handle-dialog">
          <el-form ref="banForm" :model="handleMsg" :rules="rules">
            <el-form-item prop="handleReason">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" style="visibility: collapse;">
                  <label class="handle-dialog-item-label">下架原因:</label>
                </div>
                <el-input type="textarea" v-model.trim="handleMsg.handleReason"></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item prop="sendToComplainantContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToComplainant" @change="$refs.banForm.validateField('sendToComplainantContent')">
                  <label class="handle-dialog-item-label">通知给投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToComplainant" v-model.trim="handleMsg.sendToComplainantContent"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="sendToRespondentContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToRespondent" @change="$refs.banForm.validateField('sendToRespondentContent')">
                  <label class="handle-dialog-item-label">通知给被投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToRespondent" v-model.trim="handleMsg.sendToRespondentContent"></el-input>
              </div>
            </el-form-item> -->
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="confirmBan">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="banDialogVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
        <el-dialog title="待处理操作" :visible.sync="waitDialogVisible" width="40%" class="handle-dialog">
          <el-form ref="waitForm" :model="handleMsg" :rules="rules">
            <el-form-item prop="handleReason">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" style="visibility: collapse;">
                  <label class="handle-dialog-item-label">待处理原因:</label>
                </div>
                <el-input type="textarea" v-model.trim="handleMsg.handleReason"></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item prop="sendToComplainantContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToComplainant" @change="$refs.waitForm.validateField('sendToComplainantContent')">
                  <label class="handle-dialog-item-label">通知给投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToComplainant" v-model.trim="handleMsg.sendToComplainantContent"></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="sendToRespondentContent">
              <div class="handle-dialog-item">
                <div class="checkdiv">
                  <input type="checkbox" v-model="handleMsg.sendToRespondent" @change="$refs.waitForm.validateField('sendToRespondentContent')">
                  <label class="handle-dialog-item-label">通知给被投诉人:</label>
                </div>
                <el-input type="textarea" v-show="handleMsg.sendToRespondent" v-model.trim="handleMsg.sendToRespondentContent"></el-input>
              </div>
            </el-form-item> -->
            <div class="handle-dialog-footer">
              <el-button type="primary" class="handle-dialog-footer-save" @click="confirmWait">确定</el-button>
              <el-button class="handle-dialog-footer-cancel" @click="waitDialogVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
        <el-dialog title="附件详情" :visible.sync="handledThumbnailsVisible" width="40%" class="handle-dialog">
          <div v-for="(item,index) in thumbnails" :key="index">
            <img v-if="item" :src="item" class="handle-dialog-img">
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="已审核列表" name="examed" v-if="permissions.complaint_audited_list">
        <div class="complaint-list-filter">
          <el-row>
            <!-- <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select class="complaint-list-filter-value" v-model="listQuery.targetType" clearable size="small" @change="setCategory" placeholder="内容类别">
                  <el-option
                    v-for="item in targeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select class="complaint-list-filter-value" v-model="listQuery.complaintCategoryId" clearable size="small" placeholder="举报分类">
                  <el-option
                    v-for="item in postComplaintType"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-date-picker
                  class="complaint-list-filter-date"
                  v-model="listQuery.complainedTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  size="small"
                  placeholder="创建时间">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6">
              <el-input class="complaint-list-filter-value" @keyup.enter.native="searchChange" v-model.trim="listQuery.complainedBy" size="small" placeholder="举报者Birth Name或Full Name"></el-input>
            </el-col>
             <el-col :span="6">
              <el-input class="complaint-list-filter-value" @keyup.enter.native="searchChange" v-model.trim="listQuery.complainTo" size="small" placeholder="被举报者Birth Name或Full Name"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-select class="complaint-list-filter-value" v-model="listQuery.handleResultFilter" clearable size="small" @change="changeStatus" placeholder="状态">
                  <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
             <el-col :span="18">
              <el-button class="complaint-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
              <el-button class="complaint-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
            </el-col>
          </el-row>
        </div>
          <avue-crud ref="crud"
                    :page.sync="page"
                    :data="tableData"
                    :table-loading="tableLoading"
                    :option="handledTableOption"
                    @current-change="currentChange"
                    @size-change="sizeChange">

            <template slot="complainedBy"
                      slot-scope="scope">
              <a v-if="scope.row.complainedByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedBy}}</a>
              <a v-if="scope.row.complainedByMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedBy}}</a>
            </template>

            <template slot="complainedByRealname"
                      slot-scope="scope">
              <a v-if="scope.row.complainedByMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedById);"
                  class="complaint-list-container-button">
                {{scope.row.complainedByRealname}}</a>
              <a v-else href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedByRelatedPersonalMemberId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedByRelatedPersonalRealname}}</a>
            </template>

            <template slot="complainedTo"
                      slot-scope="scope">
              <a v-if="scope.row.complainedToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedTo}}</a>
              <a v-if="scope.row.complainedToMemberType === 1" href="javascript:void(0);" @click="toOfficialMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedTo}}</a>
            </template>

            <template slot="complainedToRealname"
                      slot-scope="scope">
              <a v-if="scope.row.complainedToMemberType === 0" href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedToRealname}}</a>
              <a v-else href="javascript:void(0);" @click="toMemberDetail(scope.row.complainedToRelatedPersonalMemberId);"
                  class="complaint-list-container-button">
                {{scope.row.complainedToRelatedPersonalRealname}}</a>
            </template>

            <template slot="targetType"
                      slot-scope="scope">
                {{scope.row.targetType | formateTargetType}}
            </template>

            <template slot="handleResult"
                      slot-scope="scope">
                {{scope.row.handleResult | formateHandleResult}}
            </template>

            <template slot="thumbnailUrl"
                      slot-scope="scope">
                <a v-if="scope.row.hasAttachment" href="javascript:void(0);" @click="thumbnailDetail(scope.row.handleResult,scope.row.id)"
                  class="complaint-list-container-button">
                附件详情</a>
            </template>

            <template slot="content"
                      slot-scope="scope">
              <a href="javascript:void(0);" @click="toPostList(scope.row.targetType,scope.row.targetId);"
                  class="complaint-list-container-button">
                {{scope.row.content | formatEmptyData}}</a>
            </template>
            <template slot="autoBan"
                      slot-scope="scope">
                {{scope.row.handleResult | formateAutoBan}}
            </template>
          </avue-crud>

        <el-dialog title="附件详情" :visible.sync="unhandledThumbnailsVisible" width="40%" class="handle-dialog">
          <div v-for="(item,index) in thumbnails" :key="index">
            <img v-if="item" :src="item" class="handle-dialog-img">
          </div>
        </el-dialog>

      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
  import { fetchList, ignoreObj, banObj, waitObj, getAttachment, getAllCategoryList } from '@/api/admin/complaints'
  import { unhandledTableOption, handledTableOption, targeTypes, status } from '@/const/crud/admin/complaints'
  import { mapGetters } from 'vuex'
  export default {
    name: 'complaint',
    data() {
      const validateSendToComplainantContent = (rule, value, callback) => {
        if (this.handleMsg.sendToComplainant && value === '') {
          callback(new Error('请输入通知给投诉人的内容'))
        } else { 
          callback() 
        }
      }
      const validateSendToRespondentContent = (rule, value, callback) => {
        if (this.handleMsg.sendToRespondent && value === '') {
          callback(new Error('请输入通知给被投诉人的内容'))
        } else { 
          callback() 
        }
      }
      return {
        tableData: [],
        page: {
          total: 0, // 总记录数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 10,
          complainedTime: [],
          handleResult: undefined,
          complaintCategoryId: null,
          targetType: null,
          complainTo: '',
          complainedBy: ''
        },
        tableLoading: false,
        unhandledTableOption: unhandledTableOption,
        handledTableOption: handledTableOption,
        targeTypes: targeTypes,
        banDialogVisible: false,
        ignoreDialogVisible: false,
        waitDialogVisible: false,
        activeName: "unexamed",
        status: status,
        handleReason: undefined,
        thumbnails: undefined,
        handledThumbnailsVisible: false,
        unhandledThumbnailsVisible: false,
        categoryList: [],
        handleMsg: {
          handleReason: undefined,
          sendToComplainant: false,
          sendToComplainantContent: '',
          sendToRespondent: false,
          sendToRespondentContent: '',
        },
        rules: {
          handleReason: [
            {required: true, message: '请输入操作原因', trigger: ['blur', 'change']}
          ],
          sendToComplainantContent: [
            { validator: validateSendToComplainantContent, trigger: ['blur', 'change'] }
          ],
          sendToRespondentContent: [
            { validator: validateSendToRespondentContent, trigger: ['blur', 'change'] }
          ],
        },
      }
    },
    mounted: function() {
      this.getList()
      this.getCategoryList()
    },
    computed: {
      ...mapGetters(['permissions']),
      complainedStartTime: function () {
        if (this.listQuery.complainedTime && this.listQuery.complainedTime.length > 0) {
          return this.listQuery.complainedTime[0]
        } else {
          return null
        }
      },
      complainedEndTime: function () {
        if (this.listQuery.complainedTime && this.listQuery.complainedTime.length > 1) {
          return this.listQuery.complainedTime[1]
        } else {
          return null
        }
      },
      postComplaintType: function () {
        let postComplaintTypeList = []

        this.categoryList.forEach(element => {
          if (element.targetType === "1") postComplaintTypeList.push(element)
        });
        return postComplaintTypeList
      }
    },
    methods: {
      onTabShow(tab) {
        this.searchReset()
      },
      getList(handleResult) {
        this.tableLoading = true
        if (this.complainedStartTime && this.complainedEndTime) {
          this.listQuery.complainedStartTime = this.complainedStartTime
          let t = new Date(this.complainedEndTime)
          t.setDate(t.getDate() + 1)
          this.listQuery.complainedEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          this.listQuery.complainedStartTime = null
          this.listQuery.complainedEndTime = null
        }
        if (handleResult) {
          this.listQuery.handleResult = handleResult
        } else if(!this.listQuery.handleResult) {
          if (this.activeName == 'unexamed') {
            this.listQuery.handleResult = '0'
          } else {
            this.listQuery.handleResult = '1,2,3'
          }
        }
        if (this.listQuery.handleResultFilter) {
          this.listQuery.handleResult = this.listQuery.handleResultFilter
          if (this.listQuery.handleResult == 2) {
            this.listQuery.handleResult = '2,3';
          }
        }
        fetchList(this.listQuery).then(response => {
          var records = response.data.data.records;
          if (records && records.length > 0) {
            records.forEach(function(record) {
              if (!record.content) {
                record.content = "--"
              }
            })
          }
          this.tableData = records;
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取投诉列表失败',
            type: 'error'
          })
          this.tableLoading = false
        })
      },
      searchReset() {
        this.listQuery.complainTo = ''
        this.listQuery.complainedBy = ''
        this.listQuery.complainedTime = []
        this.listQuery.complaintCategoryId = ''
        this.listQuery.handleResult = ''
        this.listQuery.targetType = ''
        this.listQuery.handleResultFilter = ''
        this.searchChange()
      },
      searchChange() {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.getList()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.listQuery.current = val
        this.getList()
      },
      sizeChange(val) {
        this.page.currentPage = 1
        this.listQuery.current = 1
        this.page.pageSize = val
        this.listQuery.size = val
        this.getList()
      },
      getCategoryList() {
        getAllCategoryList().then(response => {
          this.categoryList = response.data.data
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取举报内容类别失败',
            type: 'error'
          })
          this.tableLoading = false
        })
      },
      banOption(row) {
        this.banDialogVisible = true
        this.handleMsg.targetType = row.targetType
        this.handleMsg.targetId = row.targetId
        this.handleMsg.id = row.id
        this.handleMsg.handleReason = row.label
        this.handleMsg.sendToComplainantContent = '亲爱的小伙伴，你对内容'+'"'+row.content+'"'+'的举报已核实，目前已将该内容下架，感谢你对社区美好氛围的贡献~'
        this.handleMsg.sendToRespondentContent = '你发布的内容'+'"'+row.content+'"'+'涉嫌违规，目前已将该内容下架~'
      },
      ignoreOption(row) {
        this.ignoreDialogVisible = true
        this.handleMsg.id = row.id
        this.handleMsg.handleReason = "不构成"+row.label
        this.handleMsg.sendToComplainantContent = '感谢你对'+'"'+row.content+'"'+'的投诉，经管理员审核确定不存在违规。'
        this.handleMsg.sendToRespondentContent = '你发布的'+'"'+row.content+'"'+'经管理员审核确定不存在违规'
      },
      waitOption(row) {
        this.waitDialogVisible = true
        this.handleMsg.id = row.id
        this.handleMsg.handleReason = row.label
        this.handleMsg.sendToComplainantContent = '感谢你对'+'"'+row.content+'"'+'的投诉。'
        this.handleMsg.sendToRespondentContent = '你发布的'+'"'+row.content+'"'+'受到投诉。'
      },
      confirmIgnore() {
        this.$refs.ignoreForm.validate((valid) => {
          if (!valid) return
          this.ignoreDialogVisible = false
          ignoreObj(this.handleMsg).then(response => {
            this.$message({
              message: '忽略操作成功',
              type: 'success'
            })
            this.refreshChange()
          }).catch(error => {
            console.error(error)
            this.$message({
              message: '忽略操作失败',
              type: 'error'
            })
          })
        })
      },
      confirmBan() {
        this.$refs.banForm.validate((valid) => {
          if (!valid) return
          this.banDialogVisible = false
          banObj(this.handleMsg).then(response => {
            this.$message({
              message: '下架操作成功',
              type: 'success'
            })
            this.refreshChange()
          }).catch(error => {
            console.error(error)
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
        })
      },
      confirmWait() {
        this.$refs.waitForm.validate((valid) => {
          if (!valid) return
          this.waitDialogVisible = false
          waitObj(this.handleMsg).then(response => {
            this.$message({
              message: '待处理操作成功',
              type: 'success'
            })
          }).catch(error => {
            console.error(error)
            this.$message({
              message: '待处理操作失败',
              type: 'error'
            })
          })
        })
      },
      thumbnailDetail(handleResult,id) {
        if(handleResult === 0) {
          this.handledThumbnailsVisible = true
        } else {
          this.unhandledThumbnailsVisible = true
        }
        getAttachment(id).then(response => {
          this.thumbnails = response.data.data
        })
      },
      clearSearchFilter() {
        this.listQuery.targetType = undefined
        this.listQuery.complaintCategoryId = undefined
        this.listQuery.complainedTime = undefined
        this.listQuery.handleResultFilter = undefined
        this.listQuery.complainedBy = undefined
        this.listQuery.complainTo = undefined
      },
      setCategory() {
        this.listQuery.complaintCategoryId = null
      },
      changeStatus() {
        this.$forceUpdate();
      },
      refreshChange() {
        if(this.listQuery.handleResult) this.getList(this.listQuery.handleResult)
        else this.getList()
      },
      toMemberDetail(ownerId) {
        this.$router.push({
          path: "/upms/member/detail/" + ownerId,
        })
      },
      toOfficialMemberDetail(ownerId) {
        this.$router.push({
          path: "/upms/member/official/detail/" + ownerId,
        })
      },
      toPostList(targetType,id) {
        if(targetType === 1) {
          this.$router.push({
            path: "/post/comment/"+id,
          })
          return
        }
        if(targetType === 0) {
          this.$router.push({
            path: "/content/list/detail/"+id,
          })
          return
        }
      },
    },
    filters: {
      formateHandleResult(val) {
        if ( val === 0 ) return '未处理'
        if ( val === 1 ) return '已忽略'
        if ( [2, 3].includes(val) ) return '已下架'
      },
      formateAutoBan(val) {
        if ( val === 3 ) return '是'
        else return '否'
      },
      formateTargetType(val) {
        if ( val === 0 ) return '内容'
        if ( val === 1 ) return '评论'
      }
    }
  }
</script>

<style lang="scss" scoped>
.complaint-list {
  padding: 0 22px;
  background: #fff;
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-item {
      width: 500px;
      display: flex;
      flex-direction: row;
      &-label {
        text-align: center;
        font-size: 14px;
        width: 110px;
        line-height: 36px;
        padding: 0 5px;
      }
      &-input {
        font-size: 14px;
        width: 300px;
        height: 36px;
      }
    }
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
    &-img {
      max-width: 500px;
    }
  }

.handle-dialog-item {
  .handle-dialog-item-label {
    width: 150px;
    text-align: left;
  }
  .checkdiv {
    width: 150px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}
/deep/ .el-form-item__error {
  left: 150px;
}

/deep/ .el-dialog__body {
  padding: 30px 20px 30px;
}

/deep/ .el-card__body {
  padding: 0;
}
</style>

